import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useSettings } from '../hooks/useSettings';

const PAYMENT_RETURN_SCRIPT =
  'https://teuteuf-web-components.pages.dev/teuteuf-payment-return.js';
const PAYMENT_RETURN_TAG = 'teuteuf-payment-return';

if (
  typeof document !== 'undefined' &&
  !customElements.get(PAYMENT_RETURN_TAG) &&
  !document.querySelector('script[data-teuteuf-payment-return]') &&
  !document.querySelector('link[data-teuteuf-payment-return-preload]')
) {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'script';
  link.href = PAYMENT_RETURN_SCRIPT;
  link.dataset.teuteufPaymentReturnPreload = '';

  document.head.appendChild(link);
}

const PaymentReturnRoute = () => {
  const { i18n } = useTranslation();
  const [settings] = useSettings();
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      window.history.replaceState(
        window.history.state,
        '',
        `${pathname}${search}`,
      );
    }
  }, [hash, pathname, search]);

  useEffect(() => {
    if (
      customElements.get(PAYMENT_RETURN_TAG) ||
      document.querySelector('script[data-teuteuf-payment-return]')
    ) {
      return;
    }

    const script = document.createElement('script');
    script.src = PAYMENT_RETURN_SCRIPT;
    script.async = true;
    script.dataset.teuteufPaymentReturn = '';
    script.onerror = () => {
      console.error('Failed to load the payment return web component');
      script.remove();
    };

    document.head.appendChild(script);
  }, []);

  const status = new URLSearchParams(search).get('status') || 'cancelled';
  const locale = (i18n.language || 'en').split('-')[0];
  const theme = settings?.theme || 'auto';

  return React.createElement(PAYMENT_RETURN_TAG, {
    status,
    lang: locale,
    gameName: 'Flagle',
    tryAgainHref: '/removeads',
    ctaText: 'Play archive',
    ctaHref: '/archive',
    theme,
  });
};

export default PaymentReturnRoute;
